import { CommandBar, FontSizes, ICommandBarItemProps, PanelType, TextField } from "@fluentui/react";

import BaseTelelirk from "../../../components/generic/baseTelerik";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import themeBase from "../../../utils/theme/themeBase";
import { BaseReportesTelerik } from "../../../components/generic/baseReportesTelerik";
import { Text } from '@fluentui/react/lib/Text';
import { useBoolean } from "@fluentui/react-hooks";
import { useEffect, useState } from "react";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import TokenService from "../../../services/Authentication/TokenService";
import { urlTelerik } from "../../../services/http-common";
import IconHelper from "../../../utils/helpers/iconHelper";
import reporteServicio from "../../../services/reporteService";
import { IExportarReporte, IParametro } from "../../../Interfaces/base/IBase";


interface Idsp {
    isOpen: boolean | undefined
    onDismiss: ((ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => void) | undefined
}
export interface IGuardia {
    Guardia: string
}

function ReporteAsignados(props: Idsp) {

    let reportName = "SSOMATabletsAsignados.trdx";
    let t = TokenService.getToken();
    let viewerRef;
    const urlTelerikR = `${urlTelerik}/reports`;

    const [key, setKey] = useState(0);

    const viewerOptions = {
        serviceUrl: urlTelerikR,
        reportSource: {
            report: reportName,
            parametros: {}
            //parameters: { "editors": { "multiSelect": { "listaVerificacionId": "50884d84-fd34-43ff-9686-179542b5a7aa" } } },
        },
        viewerContainerStyle: themeBase.telerikStyle,
        // viewerContainerStyle: viewerContainerStyle,
        // viewMode: currentViewMode,
        viewMode: 'PRINT_PREVIEW',
        // scaleMode: 'SPECIFIC',
        scaleMode: 'FIT_PAGE_WIDTH',
        scale: 1.0,
        enableAccessibility: false,
        toolbar: {
            items: [
                {
                    type: 'togglePrintPreview',
                    text: 'Print',
                    visible: true
                },
                {
                    type: 'export',
                    text: 'Export',
                    visible: false
                }
            ]
        },
        authenticationToken: t,
        // ready: function () {
        //   //this.refreshReport();
        // }

    };


    const [guardiaAux, setGuardiaAux] = useState("");
    const [filtroGuardia, setFiltroGuardia] = useState<IGuardia>({ Guardia: "A,B,C,D" });
    const [
        isOpenPanelFiltro,
        { setTrue: openPanelFiltro, setFalse: dismissPanelFiltro },
    ] = useBoolean(false);

    const _back = () => {
        setFiltroGuardia({ ...filtroGuardia, Guardia: "A,B,C,D" })
        setKey(prevKey => prevKey + 1);
        dismissPanelFiltro();
    };

    const _closePanel = () => {
        dismissPanelFiltro();
    };

    const changeFilter = () => {
        setFiltroGuardia({
            ...filtroGuardia,
            Guardia: guardiaAux
        })
        setKey(prevKey => prevKey + 1);
        setGuardiaAux("")
        dismissPanelFiltro()
    };

    const _onChangeText = (
        type: string,
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ) => {
        if (event !== undefined) {
            if (newValue !== undefined) {
                switch (type) {
                    case "guardia":
                        setGuardiaAux(newValue)
                        break;
                    default:
                        setGuardiaAux("A,B,C,D")
                        break;
                }
                console.log(newValue);
            }
        }
    };

    const transformarParametros = (parametros: IGuardia): IParametro[] => {
        return Object.entries(parametros).map(([key, value]) => ({
            Key: key,
            Value: value,
        }));
    };

    function descargarReporte(extension: string) {
        const reporteExportar: IExportarReporte = {
            report: reportName,
            Extension: extension,
            //Parametros: [{ filtroGuardia }]
        }
        reporteExportar.Parametros = transformarParametros(filtroGuardia);

        reporteServicio.exportaReporte(reporteExportar)
            .then((response) => {
                if (response.status === 200) {
                    // response.json().then((data) => {
                    //   console.log("Datos de la respuesta:", data);
                    // });
                    //   console.log("Datos de la respuesta: Reporte generado ----");
                    //   console.log(response.data);
                    
                    const dataUrl = response.data;

                    // Create a link element
                    const link = document.createElement('a');
                    link.href = dataUrl;
                    link.download = 'reporte'; // Puedes obtener el nombre del archivo de la respuesta si está disponible

                    // Simulate a click on the link to trigger the download
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                }
                else {
                    console.error("Status:", response.status);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }


    // Función para recargar el componente
    const recargarComponente = () => {
        setKey(prevKey => prevKey + 1);
    };

    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_RELOAD,
            // onClick: (arg) => actualizarTabla(),
            // onClick: () => viewerRef.refreshReport(),
            onClick: recargarComponente,
        }
    ];

    const _farItems: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_PDF,
            onClick: () => {
                descargarReporte("PDF");
            },
        },
        {
            ...IconHelper.ICON_EXCEL,
            onClick: () => {
                descargarReporte("XLSX");
            },
        },
        {
            ...IconHelper.ICON_FILTER,
            onClick: () => {
                openPanelFiltro();
            },
        }
    ];

    useEffect(() => {
        const hideExportButton = () => {
            const exportButton: any = document.querySelector("#trv-main-menu-export-command");
            // console.log(exportButton)

            if (exportButton) {
                // console.log(exportButton)
                exportButton.remove();
                // exportButton.style.display = 'none';
                clearInterval(interval);
            }
        };

        // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
        const interval = setInterval(hideExportButton, 1);

        // Limpia el intervalo al desmontar el componente
        return () => clearInterval(interval);
    }, [key]);

    // useEffect(() => {
    //     // Actualizar el estado si el prop 'formatos' cambia
    //     // recargarComponente();
    //     viewerRef.refreshReport()
    // }, [reportName]);

    return (
        <>
            <PanelGenerico
                isOpen={props.isOpen}
                onDismiss={props.onDismiss}
                enabledFooter={true}
                panelType={PanelType.large}
                enabledHeader={true}
                HeaderTitlesText={{ title: "Dispositivos Tablets Asignados" }}
            >
                <div style={themeBase._padding20}>
                    {/* <BaseTelelirk reportName="SSOMATabletsAsignados.trdx" parametros={{}} /> */}
                    {/* <BaseReportesTelerik
                        reportName="SSOMATabletsAsignados.trdx"
                        parametros={{}}
                        formatos={2}
                    /> */}
                    <div className="ms-Grid-col ms-sm12 ms-lg12">
                        <CommandBar
                            items={_items}
                            farItems={_farItems}
                            styles={themeBase.commadStyles}
                        />
                    </div>
                    <div key={key}>
                        <TelerikReportViewer
                            ref={el => viewerRef = el}
                            serviceUrl={viewerOptions.serviceUrl}
                            reportSource={{
                                report: viewerOptions.reportSource.report,
                                parameters: filtroGuardia
                            }}
                            //viewerContainerStyle={viewerOptions.viewerContainerStyle}
                            viewerContainerStyle={viewerOptions.viewerContainerStyle}
                            parametersAreaVisible={true}
                            viewMode={viewerOptions.viewMode}
                            scaleMode={viewerOptions.viewMode}
                            scale={viewerOptions.viewMode}
                            enableAccessibility={viewerOptions.enableAccessibility}
                            authenticationToken={viewerOptions.authenticationToken}
                            toolbarItems={viewerOptions.toolbar.items}
                            skipBlankPages={false}
                        />
                    </div>
                </div>
                <PanelGenerico
                    HeaderTitlesText={
                        {
                            title: "Filtros",
                            // subTitle2: filtroGuardia.Guardia
                            //subTitle2: `Filto aplicado: ${filtroGuardia.Guardia}`
                        }}
                    enabledHeader
                    isOpen={isOpenPanelFiltro}
                    onDismiss={_closePanel}
                    panelType={PanelType.smallFixedFar}
                    cancelar={_back}
                    //objectRenderBodyHelp={{ ...form, val: equal }}
                    //disabledRegister={disableForm}
                    textRegister='Filtrar'
                    textCancel='Limpiar filtro'
                    registrar={changeFilter}
                >
                    <div>
                        <div key={filtroGuardia.Guardia}
                            style={{ fontSize: FontSizes.size10 }}
                        >
                            <Text
                                style={{ fontSize: FontSizes.size10, color: '#626264' }}
                            // nowrap block
                            >
                                <span style={{ marginRight: '8px' }}>✓</span>
                                {`Guardia: ${filtroGuardia.Guardia}`
                                }
                            </Text>
                        </div>
                        <br />
                        <TextField
                            label="Guardia:"
                            placeholder="A,B,C,D"
                            onChange={(e, o) => _onChangeText("guardia", e, o)}
                            autoComplete="on"
                            type="text"
                        />
                    </div>
                </PanelGenerico>
            </PanelGenerico>
        </>
    );
}

export default ReporteAsignados;

